import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ASlideVolume, PlaylistRemoteAppState} from '../../../store';
import {NgRedux} from '@angular-redux3/store';
import {PlayerService} from '../../../containers/player/player.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'mwo-volume-dialog',
  templateUrl: './volume-dialog.component.html',
  styleUrls: ['./volume-dialog.component.scss']
})
export class VolumeDialogComponent implements OnInit {
  volume = 50;
  disabled = false;
  percent: number;

  @ViewChild('volumeDialogContent', {static: true}) dialogContent: ElementRef;

  constructor(private renderer: Renderer2,
              private el: ElementRef,
              private ngRedux: NgRedux<PlaylistRemoteAppState>,
              private playerService: PlayerService,
              private dialogRef: MatDialogRef<VolumeDialogComponent>) {
  }

  setSliderView() {
    const percent100 = this.volume;
    const slider = this.el.nativeElement.querySelector('#volume');

    if (this.disabled) {
      this.renderer.setStyle(slider, 'backgroundImage', `linear-gradient(90deg,
      rgba(128, 128, 128, 0.5) 0%,
      rgba(128, 128, 128, 0.5) ${percent100}%,
      rgba(192, 192, 192, 0.5) ${percent100}%,
      rgba(192, 192, 192, 0.5) 100%)`);
    } else {
      this.renderer.setStyle(slider, 'backgroundImage', `linear-gradient(90deg,
      rgba(255, 82, 82, 1) 0%,
      rgba(255, 0, 0, 0.7) ${percent100}%,
      rgba(255, 255, 255, 0.3) ${percent100}%,
      rgba(255, 255, 255, 0.7) 100%)`);
    }
  }

  getVolumeIcon() {
    if (this.volume === 0) {
      return 'assets/icons/volume_mute.svg';
    } else if (this.volume < 50) {
      return 'assets/icons/volume_low.svg';
    } else {
      return 'assets/icons/volume_full.svg';
    }
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = false;
    this.playerService.volume$.subscribe(volume => {
      this.volume = volume;
      this.setSliderView();
    });

    //On ajoute un évènement sur le background de la popup afin de la fermer si on clique dessus
    this.dialogContent.nativeElement.addEventListener('click', () => {
      if (!this.disabled) {
        this.dialogRef.close();
      }
    });

    //On désactive le click qui fait quitter la popup sur les boutons de changement de volume
    const volumeElements = this.el.nativeElement.querySelectorAll('.volume-change-button');
    volumeElements.forEach(element => {
      this.renderer.listen(element, 'click', (event) => {
        event.stopPropagation(); // Arrête la propagation de l'événement de clic
      });
    });
  }

  handleVolumeChangeButtonClicked(remove: boolean) {
    if (!this.disabled) {
      this.disabled = true;
      this.dialogRef.disableClose = true;
      this.volume = remove ? this.volume - 10 : this.volume + 10;
      if (this.volume < 0) {
        this.volume = 0;
      }
      if (this.volume > 100) {
        this.volume = 100;
      }
      this.ngRedux.dispatch(ASlideVolume(this.volume));
      this.setSliderView();

      setTimeout(() => {
        this.disabled = false;
        this.dialogRef.disableClose = false;
        this.setSliderView();
      }, 2000);
    }
  }
}
